module.exports = __webpack_public_path__ + "static/media/tini-data.719aa54d.png";